<template>
  <div class="container">
    <div class="selection">
      <h4>{{ $t('admin.column.title') }}</h4>
      <a-button type="primary" @click="create">{{ $t('admin.column.create') }}</a-button>
    </div>
    <div v-if="pagination.total === 0" class="nodata">
      <img src="@/assets/img/bj_zanwushujv.png" alt="">
      <div>
        <div class="text">{{ $t('admin.column.noData') }}</div>
      </div>
    </div>
    <a-table
      v-else
      row-key="id"
      :columns="columns"
      :data-source="data">
      <template slot="sort" slot-scope="text, record, index">
        <div class="sort">
          <a-icon type="arrow-up" @click="sort(record.id, 'up')" v-if="index > 1" />
          <a-icon type="arrow-down" @click="sort(record.id, 'down')" v-if="index > 0 && index < data.length - 1" />
        </div>
      </template>
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <span @click="edit(record)">{{ $t('admin.column.actions.edit') }}</span>
          <span @click="delModal(record.id)" v-if="![2, 90, 91].includes(record.type)">{{ $t('admin.column.actions.delete') }}</span>
        </div>
      </template>
    </a-table>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('admin.column.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('admin.column.deleteConfirm.content')}</p>`" />
  </div>
</template>

<script>
import {
  columnDel,
  columnList,
  columnUp,
  columnDown,
  columnType
} from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import { EventBus } from '@/utils/eventBus'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      delId: undefined,
      delVisible: false,
      columns: [
        {
          title: this.$t('admin.column.columns.id'),
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: this.$t('admin.column.columns.mainColumnName'),
          dataIndex: 'title'
        },
        {
          title: this.$t('admin.column.columns.subColumnCount'),
          dataIndex: 'subColumnNum'
        },
        {
          title: this.$t('admin.column.columns.columnType'),
          dataIndex: 'typeName'
        },
        {
          title: this.$t('admin.column.columns.status'),
          dataIndex: 'statusName'
        },
        {
          title: this.$t('admin.column.columns.createdAt'),
          dataIndex: 'createdAt'
        },
        {
          title: this.$t('admin.column.columns.sort'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' }
        },
        {
          title: this.$t('admin.column.columns.operations'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    handleTableChange() {
      this.getColumnList()
    },
    create() {
      if (this.data.length >= 8) {
        this.$message.warning(this.$t('admin.column.messages.columnLimit'))
        return
      }
      this.$router.push({
        name: 'columnAdd'
      })
    },
    async sort(id, type) {
      const data = {
        id
      }
      if (type === 'up') {
        await columnUp(data)
      } else {
        await columnDown(data)
      }
      this.getColumnList()
      this.$message.success(this.$t('admin.column.messages.sortSuccess'))
    },
    edit(record) {
      this.$router.push({
        name: 'columnAdd',
        query: {
          id: record.id
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      columnDel({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getColumnList()
          this.$message.success(this.$t('admin.column.messages.deleteSuccess'))
          EventBus.$emit('RemoveSubColumn')
        }
      })
    },
    getColumnList() {
      const data = {
        page: this.pagination.page
      }
      columnList(data).then(res => {
       if (res.code == 200) {
        this.data = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        this.data.forEach(item => {
          item.typeName = this.typeList.find(type => type.id === item.type).name
        })
        nameMap(this.data)
        this.pagination.total = res.data.total
        const permissionList = localStorage.permissionList
        this.noPermissionModal = !permissionList || !permissionList.includes('admin_column')
       }
     })
    },
    async getTypeList() {
      const res = await columnType()
      if (res.code == 200) {
        this.typeList = res.data.list
      }
    }
  },
  async mounted() {
    await this.getTypeList()
    this.getColumnList()
  }
}
</script>

<style lang="less" scoped>
.container{
  /deep/ .ant-table {
    min-height: 583px;
  }
  position: relative;
  .list-pagination{
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
.sort{
  display: flex;
  justify-content: center;
  width: 100%;
  color: #5C6F95;
  i:hover{
    color: #FFBFA6;
  }
}
.selection{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix{
      >img{
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear{
      width: 14px;
      height: 14px;
    }
  }
}
.nodata{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  justify-content: center;
  flex-direction: column;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  >div{
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text{
      font-weight: 550;
      color: #0D2340;
      margin-bottom: 12px;
    }
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
